module.exports = __webpack_public_path__ + "static/img/14085A_1_C_20240513_fit.26e2938.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14085A_1_C_20240513_fit.png
// module id = JgQ9
// module chunks = 0